import { setServerUrl, getUseAPIFrontend, getAPIFrontend, setHeaders } from "typed-client-server-api/hooks";

import { API } from "../../types";

if (process.env.NODE_ENV === "development") {
    setServerUrl("http://localhost:" + process.env.PORT_SERVER);
}

let authorization = "";

setHeaders(() => ({
    "Content-Type": "application/json",
    "Authorization": authorization,
}));

export function getServerUrl() {
    if (process.env.NODE_ENV === "development")
        return "http://localhost:" + process.env.PORT_SERVER;

    return "";
}
export function getAuthorizationHeader() {
    return authorization;
}
export function setAuthorizationHeader(newAuthorization: string) {
    authorization = newAuthorization;
}

export const api = getAPIFrontend<API>();
export const useApi = getUseAPIFrontend<API>();
